import $ from 'jquery';
import _ from './underscore_extend';
import Application from './application';
import mobile from './mobile';


var base = function(options) {
    // forms: decoration
    var activeElementSelector = (options || {}).activeElementSelector || 'input:not([readonly=readonly])',
        replaceFormButtonWithLink = function() {
        // Hides button, and allows the corresponding link to submit the form.
        // It DOES NOT support replacing multiple buttons inside a single form.
        // Example markup:
        // <form>
        //     ...
        //     <input class="js-form-button" type="submit" name="action_cancel" value="Cancel" />
        //     <a class="js-form-button-link" href="#" style="display:none">Cancel</a>
        //     ...
        // </form>

        var button = $('.js-form-button', this);
        if (button.length !== 1) {
            // Processing forms with 0 buttons is useless;
            // processing ones with >1 buttons is harmful
            // (it implies rather vague logic of matching buttons to links).
            return;
        }

        var link = $('.js-form-button-link', this);
        if (link.length === 0) {
            // Inside a single form, it is acceptable to have
            // >= 1 links acting as a cancel link.
            return;
        }

        link.click(function() {
            button.click();
            return false;
        });
        link.show();
        button.hide();
    };


    // mocks for Portal legacy
    // TODO: refactor into something reusable and move to an appropriate place

    // Drop-down menus in global navigation
    $(function() {
        /**
         * Drop-down menus should have .js-menu class,
         * links to open these menus — .js-menu-link class.
         * Opening and closing a menu toggles .js-open class on it.
         *
         * Click on a closed menu opens it, and closes all other opened menus;
         * click on an opened menu closes it;
         * click on a document body closes all opened menus.
         *
         * A ui.menu.close event triggered on a document body
         * closes all opened menus.
         */

        var openedClass = 'js-open',
            closeEvent = 'ui.menu.close',

            body = $('body'),
            bindToCloseEvent = function(callback) {
                body.on(closeEvent, callback);
            },
            triggerCloseEvent = function(event) {
                body.trigger(closeEvent);
            },
            handleCloseEvent = function(event) {
                var target = event ? $(event.target) : null,
                    triggeredFromMenu = target && target.parents('#js-menu-wrapper').length;

                if (triggeredFromMenu) {
                    return true;
                }

                triggerCloseEvent(event);
            };

        if (mobile().useTouchDevice) {
            body.on('touchstart', handleCloseEvent);
        } else {
            body.click(handleCloseEvent);
        }

        var MenuView = Backbone.View.extend({
            menuSelector: '.js-menu',
            initialize: function(options) {
                var closeThis = _.bind(function() {
                    this.close($(this.menuSelector).filter('.' + openedClass));
                }, this);
                body.on('click', '.js-menu-link', _.bind(this.toggle, this));
                bindToCloseEvent(closeThis);
            },
            toggle: function(event) {
                var $target = $(event.currentTarget),
                    $menuElement = $target.closest(this.menuSelector);
                // prevent click propagating to body
                event.preventDefault();
                event.stopPropagation();

                if (this.opened($menuElement)) {
                    this.close($menuElement);
                } else {
                    handleCloseEvent();
                    this.open($menuElement);
                }
            },
            opened: function($el) {
                return $el.hasClass(openedClass);
            },
            open: function($el) {
                $el.addClass(openedClass);
            },
            close: function($el) {
                $el.removeClass(openedClass);
            }
        });

        var MobileMenuView = MenuView.extend({
            menuSelector: '.js-mobile-menu,.js-menu',
            initialize: function(options) {
                MenuView.prototype.initialize.apply(this, arguments);

                body.on('click', '.js-submenu-link', _.bind(this.toggleSubmenu, this));

                bindToCloseEvent(_.bind(this.closeAllSubmenus, this));
            },
            getSubmenu: function($menuLink) {
                return $($menuLink.data('menu-content-selector'));
            },
            open: function($menuElement) {
                MenuView.prototype.open.apply(this, arguments);
                this.getSubmenu($menuElement).show();
            },
            close: function($menuElement) {
                MenuView.prototype.close.apply(this, arguments);
                this.getSubmenu($menuElement).hide();
            },
            toggleSubmenu: function(event) {
                var $submenu = $(event.target).parents('li');
                if (this.openedSubmenu($submenu)) {
                    this.closeSubmenu($submenu);
                } else {
                    this.closeAllSubmenus();
                    this.openSubmenu($submenu);
                }

                // prevent click propagating to body
                event.preventDefault();
                event.stopPropagation();
            },
            openedSubmenu: function(submenu) {
                return submenu.hasClass(openedClass);
            },
            openSubmenu: function(submenu) {
                submenu.addClass(openedClass);
            },
            closeSubmenu: function(submenu) {
                submenu.removeClass(openedClass);
            },
            closeAllSubmenus: function() {
                $('.js-submenu.' + openedClass).each(_.bind(function(idx, submenu) {
                    this.closeSubmenu($(submenu));
                }, this));
            }
        });


        var globalNav = $('.js-global-nav')
        if (globalNav.length > 0) {
            globalNav.each(function() {
                var view;
                if ($('.js-mobile-menu', this).length > 0) {
                    view = new MobileMenuView({el: this});
                } else {
                    view = new MenuView({el: this});
                }
            });
        } else {
            function onCmLoadError() {
                window.removeEventListener('WG.CM.LoadError', onCmLoadError);
                $('.js-global-nav').each(function() {
                    var view;
                    if ($('.js-mobile-menu', this).length > 0) {
                        view = new MobileMenuView({el: this});
                    } else {
                        view = new MenuView({el: this});
                    }
                });
            }
            window.addEventListener('WG.CM.LoadError', onCmLoadError);
        }

        body.on('click', '.js-auth-logout-link', function(event) {
            event.preventDefault();
            Application.trigger('menu-logout', event);
        });
    });

    $(function() {
        $('form').each(function() {
            replaceFormButtonWithLink.apply(this);
        });
    });

    var setupAutoHeight = _.debounce(function(context, reset) {
        var autoHeightBlock;
        if (context) {
            autoHeightBlock = $('.js-autoheight', context);
        } else {
            autoHeightBlock = $('.js-autoheight');
        }

        if (autoHeightBlock.length === 0) {
            return;
        }

        autoHeightBlock.each(function() {
            var $this = $(this),
                $autoHeightItems = $this.find('.js-autoheight-item:visible'),
                columns = $this.data('columns') || 2,
                chunks = [], i;


            /* Slice visible elements into chunks by columns count */
            for (i = 0; i < $autoHeightItems.length; i += columns) {
                chunks.push($autoHeightItems.slice(i, i + columns));
            }

            _.each(chunks, function($items) {

                var maxHeight = 0,
                    itemHeight = 0,
                    childrenHeight = 0, i,
                    $children = $items.children();

                if (reset) {
                    $children.innerHeight('auto');
                }

                $items.each(function() {
                    var $children = $(this).children();
                    if ($children.length === 1) {
                        childrenHeight = $children.innerHeight();
                        if (childrenHeight > maxHeight) {
                            maxHeight = childrenHeight;
                        }
                    } else {
                        itemHeight = $(this).innerHeight();
                        if (itemHeight > maxHeight) {
                            maxHeight = itemHeight;
                        }
                    }
                });

                if (childrenHeight !== 0) {
                    $children.innerHeight(maxHeight);
                } else {
                    $items.innerHeight(maxHeight);
                }

            });
        });

    });
    $(function() {
        setupAutoHeight();
    });

    var resetAutoHeight = function(context) {
        var reset = true;
        setupAutoHeight(context, reset);
    };
    Application.on('ui.autoheight.reset-request', resetAutoHeight);

    var modifierClass = function(blockClass, modifier) {
            return blockClass + '__' + modifier;
        },
        getFieldWrapper = function(event, wrapperBlock) {
            var $field = $(event.target),
                selector = '.' + wrapperBlock;
            return $field.parents(selector).first();
        },
        setFieldFocusStyle = function(event) {
            getFieldWrapper(event, this.wrapperBlock).addClass(this.wrapperFocusClass);
        },
        resetFieldFocusStyle = function(event) {
            var wrapper = getFieldWrapper(event, this.wrapperBlock),
                prevent = $('.js-input-prevent-reset-focus:hover', wrapper);

            if (prevent.length) {
                return false;
            }

            wrapper.removeClass(this.wrapperFocusClass);
        },
        setFieldHoverStyle = function(event) {
            getFieldWrapper(event, this.wrapperBlock).addClass(this.wrapperHoverClass);
        },
        resetFieldHoverStyle = function(event) {
            getFieldWrapper(event, this.wrapperBlock).removeClass(this.wrapperHoverClass);
        },
        initializeElementsEvents = function(fields, wrapperBlock) {
            var wrapperHoverClass = modifierClass(wrapperBlock, 'hover'),
                wrapperFocusClass = modifierClass(wrapperBlock, 'focus'),

                fieldEventHandler = (function(context) {
                    return function(handler) {
                        return _.bind(handler, context);
                    };
                })({
                    wrapperBlock: wrapperBlock,
                    wrapperFocusClass: wrapperFocusClass,
                    wrapperHoverClass: wrapperHoverClass
                });

            var init = function(field) {
                var $field = $(field);

                $field.focus(fieldEventHandler(setFieldFocusStyle));
                $field.blur(fieldEventHandler(resetFieldFocusStyle));
                $field.mouseenter(fieldEventHandler(setFieldHoverStyle));
                $field.mouseleave(fieldEventHandler(resetFieldHoverStyle));
            };

            _.each(fields, init);
        };
    var initializeAllElementsEvents = function(context) {
        var inputElementsNotReadonlySelector = $(activeElementSelector, context);
        initializeElementsEvents(inputElementsNotReadonlySelector, 'form-input');
        initializeElementsEvents(inputElementsNotReadonlySelector, 'input-light');
        initializeElementsEvents(inputElementsNotReadonlySelector, 'input-game');
        initializeElementsEvents($('textarea', context), 'form-textarea');
    };

    Application.on('ui.elements.setup-events', function(options) {
        if (options.fields && options.wrapperBlock) {
            initializeElementsEvents(options.fields, options.wrapperBlock);
        } else {
            initializeAllElementsEvents(options.context);
        }
    });

    $(function() {
        initializeAllElementsEvents(document);
    });

}

export default base;



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/lib/base.js